import React from 'react';
import { CustomerPackagesManager } from '../CustomerPackagesManager';

interface Props {
  customerId: string;
  customerName: string;
}

export function CustomerTabPackages({ customerId, customerName }: Props) {
  return (
    <div className="animate-fade-in">
      <CustomerPackagesManager customerId={customerId} customerName={customerName} />
    </div>
  );
}
